import { render, staticRenderFns } from "./DetectionEventSlot.vue?vue&type=template&id=0fe3654f&scoped=true"
import script from "./DetectionEventSlot.vue?vue&type=script&lang=js"
export * from "./DetectionEventSlot.vue?vue&type=script&lang=js"
import style0 from "./DetectionEventSlot.vue?vue&type=style&index=0&id=0fe3654f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe3654f",
  null
  
)

export default component.exports